'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/upsell.ejs');
const templateCSS = require('../templates/upsell.css.ejs');
const CSSView = require('./css');

module.exports = Backbone.View.extend({
    className: 'upsell-exit',
    events: {
        'click .upsell-mtv-close': 'closeModal'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render', 'closeModal');

        options = options || {};
        this.model = options.model;
        this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);
        this.$el.addClass(this.style_id);
    },
    /**
     *
     */
    render: function () {
      if(this.CSSView) this.CSSView.remove();

      this.CSSView = new CSSView({
        model: { backgroundImage: this.model.backgroundImage.url },
        namespace: '.' + this.style_id + '.' + this.className,
        template: templateCSS
      });

      Backbone.$('head').append(this.CSSView.render().$el);
      this.$el.html(template(this.model));
      return this;
    },

    closeModal: function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if(this.CSSView) this.CSSView.remove();
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
});



// WEBPACK FOOTER //
// ./app/scripts/views/upsell.js